/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Date custom scalar type */
  Date: any;
};

export type AudioResult = {
  __typename?: 'AudioResult';
  packets?: Maybe<Scalars['String']>;
  questions?: Maybe<Scalars['String']>;
};

export type Clinic = {
  __typename?: 'Clinic';
  city?: Maybe<Scalars['String']>;
  clinicId: Scalars['String'];
  country?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  patients?: Maybe<Array<Maybe<Patient>>>;
  province?: Maybe<Scalars['String']>;
};

export type ClinicWebUserInfo = {
  __typename?: 'ClinicWebUserInfo';
  active?: Maybe<Scalars['Boolean']>;
  city?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

export type InitiateVisitInput = {
  assocPhysician?: InputMaybe<Scalars['String']>;
  clinicId: Scalars['String'];
  createdAt: Scalars['Date'];
  patientId: Scalars['String'];
  patientIdType: Scalars['String'];
  urgency?: InputMaybe<Scalars['String']>;
  visitId: Scalars['String'];
  waitingFor?: InputMaybe<Scalars['String']>;
};

export type LabDisplay = {
  actualDate?: InputMaybe<Scalars['String']>;
  doctorNote?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['String']>;
  labId: Scalars['String'];
  labInformation?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  needRead: Scalars['Boolean'];
  patientId: Scalars['String'];
  patientIdType: Scalars['String'];
  test: Scalars['String'];
};

export type LabOutput = {
  __typename?: 'LabOutput';
  actualDate?: Maybe<Scalars['Date']>;
  doctorNote?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['Date']>;
  labId: Scalars['String'];
  labInformation?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  needRead: Scalars['Boolean'];
  patientId: Scalars['String'];
  patientIdType: Scalars['String'];
  test: Scalars['String'];
};

export type Medication = {
  __typename?: 'Medication';
  dosage: Scalars['String'];
  medicationId: Scalars['String'];
  name: Scalars['String'];
  patientId: Scalars['String'];
  patientIdType: Scalars['String'];
  schedule?: Maybe<Array<Maybe<Scalars['Int']>>>;
  status: Scalars['String'];
};

export type MedicationCreation = {
  dosage: Scalars['String'];
  medicationId: Scalars['String'];
  name: Scalars['String'];
  patientId: Scalars['String'];
  patientIdType: Scalars['String'];
  schedule?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  status?: InputMaybe<Scalars['String']>;
};

export type MedicationDay = {
  __typename?: 'MedicationDay';
  completions: Array<Maybe<MedicationDayCompletion>>;
  day: Scalars['String'];
  patientId: Scalars['String'];
  patientIdType: Scalars['String'];
};

export type MedicationDayCompletion = {
  __typename?: 'MedicationDayCompletion';
  medicationId: Scalars['String'];
  scheduledTime: Scalars['Int'];
  takenAt: Scalars['String'];
};

export type MedicationDayCompletionInput = {
  medicationId: Scalars['String'];
  scheduledTime: Scalars['Int'];
  takenAt: Scalars['String'];
};

export type MedicationDayCompletionUpdate = {
  medicationId: Scalars['String'];
  scheduledTime: Scalars['Int'];
  takenAt?: InputMaybe<Scalars['String']>;
};

export type MedicationDayCreation = {
  completions?: InputMaybe<Array<InputMaybe<MedicationDayCompletionInput>>>;
  day: Scalars['String'];
  patientId: Scalars['String'];
  patientIdType: Scalars['String'];
};

export type MedicationDayUpdate = {
  completionUpdates: Array<InputMaybe<MedicationDayCompletionUpdate>>;
  day: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addMedicationPhoto?: Maybe<Scalars['String']>;
  createLab?: Maybe<LabOutput>;
  createMedication?: Maybe<Medication>;
  createMedicationDay?: Maybe<MedicationDay>;
  createPatient?: Maybe<Patient>;
  createRecording?: Maybe<Recording>;
  createSiteNote?: Maybe<SiteNote>;
  createVisit?: Maybe<Visit>;
  createVitals?: Maybe<Vitals>;
  createWebUser?: Maybe<WebUser>;
  deleteRecording?: Maybe<Scalars['Boolean']>;
  generateAssessment?: Maybe<Scalars['String']>;
  initiateVisit?: Maybe<Visit>;
  login?: Maybe<WebUser>;
  logout?: Maybe<Scalars['Boolean']>;
  patientLogin?: Maybe<Patient>;
  startTranscriptionSession?: Maybe<Scalars['String']>;
  transcribeAudio?: Maybe<Scalars['String']>;
  updateMedicationDay: Array<Maybe<MedicationDay>>;
  updatePatient?: Maybe<Patient>;
  updateRecordingNotes?: Maybe<Recording>;
  updateRecordingStatus?: Maybe<Recording>;
  updateVisitDetails?: Maybe<Visit>;
  updateVisitProgress?: Maybe<Visit>;
};


export type MutationAddMedicationPhotoArgs = {
  patient: PatientId;
  photoId: PhotoId;
};


export type MutationCreateLabArgs = {
  lab: LabDisplay;
};


export type MutationCreateMedicationArgs = {
  medication: MedicationCreation;
};


export type MutationCreateMedicationDayArgs = {
  medicationDay: MedicationDayCreation;
};


export type MutationCreatePatientArgs = {
  patient: PatientCreation;
};


export type MutationCreateRecordingArgs = {
  recording: RecordingInput;
};


export type MutationCreateSiteNoteArgs = {
  note: SiteNoteInput;
};


export type MutationCreateVisitArgs = {
  clinicId: Scalars['String'];
  createdAt: Scalars['Date'];
  patientId: Scalars['String'];
  patientIdType: Scalars['String'];
  visit: VisitInput;
  visitId: Scalars['String'];
};


export type MutationCreateVitalsArgs = {
  createdAt: Scalars['Date'];
  eventId: Scalars['String'];
  eventType: Scalars['String'];
  patientId: Scalars['String'];
  patientIdType: Scalars['String'];
  vitals: VitalsInput;
};


export type MutationCreateWebUserArgs = {
  webUser: WebUserInput;
};


export type MutationDeleteRecordingArgs = {
  recording: RecordingKeys;
};


export type MutationGenerateAssessmentArgs = {
  clinicId: Scalars['String'];
  sessionId: Scalars['String'];
  visitId: Scalars['String'];
};


export type MutationInitiateVisitArgs = {
  visitInfo: InitiateVisitInput;
};


export type MutationLoginArgs = {
  password: Scalars['String'];
  username: Scalars['String'];
};


export type MutationPatientLoginArgs = {
  password: Scalars['String'];
  patientId: Scalars['String'];
  patientIdType: Scalars['String'];
};


export type MutationStartTranscriptionSessionArgs = {
  visitId: Scalars['String'];
};


export type MutationTranscribeAudioArgs = {
  audio: Scalars['String'];
  sessionId: Scalars['String'];
  visitId: Scalars['String'];
};


export type MutationUpdateMedicationDayArgs = {
  completionUpdates: Array<InputMaybe<MedicationDayUpdate>>;
  patientId: Scalars['String'];
  patientIdType: Scalars['String'];
};


export type MutationUpdatePatientArgs = {
  patient: PatientUpdate;
};


export type MutationUpdateRecordingNotesArgs = {
  recording: RecordingKeys;
  updates: RecordingNotesUpdate;
};


export type MutationUpdateRecordingStatusArgs = {
  recording: RecordingKeys;
  status: RecordingStatusUpdate;
};


export type MutationUpdateVisitDetailsArgs = {
  clinicId: Scalars['String'];
  visitDetails: VisitInput;
  visitId: Scalars['String'];
};


export type MutationUpdateVisitProgressArgs = {
  clinicId: Scalars['String'];
  visitId: Scalars['String'];
  visitProgress: VisitProgress;
};

export type Patient = {
  __typename?: 'Patient';
  allergies?: Maybe<Array<Maybe<Scalars['String']>>>;
  birthday?: Maybe<Scalars['Date']>;
  firstName?: Maybe<Scalars['String']>;
  hash?: Maybe<Scalars['String']>;
  labs?: Maybe<Array<Maybe<LabOutput>>>;
  lastName?: Maybe<Scalars['String']>;
  medicationDays?: Maybe<Array<Maybe<MedicationDay>>>;
  medications?: Maybe<Array<Maybe<Medication>>>;
  patientId: Scalars['String'];
  patientIdType: Scalars['String'];
  photoDownloadUrl?: Maybe<Scalars['String']>;
  photoUploadUrl?: Maybe<Scalars['String']>;
};

export type PatientCreation = {
  allergies?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  birthday: Scalars['Date'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  patientId: Scalars['String'];
  patientIdType: Scalars['String'];
};

export type PatientId = {
  patientId: Scalars['String'];
  patientIdType: Scalars['String'];
};

export type PatientUpdate = {
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  patientId: Scalars['String'];
  patientIdType: Scalars['String'];
};

export type PhotoId = {
  photoId: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  audioResults?: Maybe<AudioResult>;
  clinic?: Maybe<Clinic>;
  patient?: Maybe<Patient>;
  patientsById?: Maybe<Array<Maybe<Patient>>>;
  recording: Recording;
  recordings: Array<Maybe<Recording>>;
  recordingsById: Array<Maybe<Recording>>;
  siteNotes: Array<Maybe<SiteNote>>;
  siteNotesById: Array<Maybe<SiteNote>>;
  userForSession?: Maybe<WebUser>;
  usersForRole?: Maybe<Array<Maybe<Scalars['String']>>>;
  visit?: Maybe<Visit>;
  visits: Array<Maybe<Visit>>;
  vitals?: Maybe<Vitals>;
};


export type QueryAudioResultsArgs = {
  audioId: Scalars['String'];
};


export type QueryClinicArgs = {
  clinicId: Scalars['String'];
};


export type QueryPatientArgs = {
  id: Scalars['String'];
  patientIdType: Scalars['String'];
};


export type QueryPatientsByIdArgs = {
  ids: Array<PatientId>;
};


export type QueryRecordingArgs = {
  id: Scalars['String'];
};


export type QueryRecordingsArgs = {
  criteria: RecordingQueryInput;
};


export type QueryRecordingsByIdArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
};


export type QuerySiteNotesArgs = {
  criteria: SiteNoteQueryInput;
};


export type QuerySiteNotesByIdArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
};


export type QueryUsersForRoleArgs = {
  role: Scalars['String'];
};


export type QueryVisitArgs = {
  clinicId: Scalars['String'];
  visitId: Scalars['String'];
};


export type QueryVisitsArgs = {
  criteria: VisitCriteria;
};


export type QueryVitalsArgs = {
  eventId: Scalars['String'];
  eventType: Scalars['String'];
  patientId: Scalars['String'];
  patientIdType: Scalars['String'];
};

export type Recording = {
  __typename?: 'Recording';
  altTranscription?: Maybe<Scalars['String']>;
  assignedTo?: Maybe<Scalars['String']>;
  correctedTranscription?: Maybe<Scalars['String']>;
  downloadUrl?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  originalTranscription?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  patientIdType?: Maybe<Scalars['String']>;
  recordedAt?: Maybe<Scalars['Date']>;
  recordingId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  uploadUrl?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['String']>;
};

export type RecordingInput = {
  patientId?: InputMaybe<Scalars['String']>;
  patientIdType?: InputMaybe<Scalars['String']>;
  recordedAt: Scalars['Date'];
  recordingId: Scalars['String'];
  user: Scalars['String'];
};

export type RecordingKeys = {
  recordingId: Scalars['String'];
  user: Scalars['String'];
};

export type RecordingNotesUpdate = {
  altTranscription?: InputMaybe<Scalars['String']>;
  correctedTranscription?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  originalTranscription?: InputMaybe<Scalars['String']>;
};

export type RecordingQueryInput = {
  assignedTo?: InputMaybe<Scalars['String']>;
  recordedBy?: InputMaybe<Scalars['String']>;
  since?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<Scalars['String']>;
};

export type RecordingStatusUpdate = {
  assignedTo?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type SiteNote = {
  __typename?: 'SiteNote';
  createdAt?: Maybe<Scalars['Date']>;
  downloadUrl?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  noteId?: Maybe<Scalars['String']>;
  uploadUrl?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['String']>;
};

export type SiteNoteInput = {
  createdAt: Scalars['Date'];
  filename: Scalars['String'];
  noteId: Scalars['String'];
  user: Scalars['String'];
};

export type SiteNoteQueryInput = {
  since?: InputMaybe<Scalars['Date']>;
};

export type Visit = {
  __typename?: 'Visit';
  assocPhysician?: Maybe<Scalars['String']>;
  backPainPoints?: Maybe<Array<Maybe<Scalars['Int']>>>;
  chiefComplaint?: Maybe<Scalars['String']>;
  clinicId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  frontPainPoints?: Maybe<Array<Maybe<Scalars['Int']>>>;
  noteToPhysician?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['String']>;
  patientIdType?: Maybe<Scalars['String']>;
  questions?: Maybe<Scalars['String']>;
  transcription?: Maybe<Scalars['String']>;
  reasonForComing?: Maybe<Scalars['String']>;
  urgency?: Maybe<Scalars['String']>;
  visitId: Scalars['String'];
  waitingFor?: Maybe<Scalars['String']>;
};

export type VisitCriteria = {
  clinicId: Scalars['String'];
  physician?: InputMaybe<Scalars['String']>;
  waitingFor?: InputMaybe<Scalars['String']>;
};

export type VisitInput = {
  chiefComplaint?: InputMaybe<Scalars['String']>;
  noteToPhysician?: InputMaybe<Scalars['String']>;
  reasonForComing?: InputMaybe<Scalars['String']>;
};

export type VisitProgress = {
  assocPhysician?: InputMaybe<Scalars['String']>;
  nextStep?: InputMaybe<Scalars['String']>;
  urgency?: InputMaybe<Scalars['String']>;
};

export type Vitals = {
  __typename?: 'Vitals';
  backPainPoints?: Maybe<Array<Maybe<Scalars['Int']>>>;
  bloodOxygen?: Maybe<Scalars['Int']>;
  diastolicBloodPressure?: Maybe<Scalars['Int']>;
  eventId: Scalars['String'];
  eventType: Scalars['String'];
  frontPainPoints?: Maybe<Array<Maybe<Scalars['Int']>>>;
  heartRate?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  patientId: Scalars['String'];
  patientIdType: Scalars['String'];
  respiratoryRate?: Maybe<Scalars['Int']>;
  systolicBloodPressure?: Maybe<Scalars['Int']>;
  temperature?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Int']>;
};

export type VitalsInput = {
  backPainPoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  bloodOxygen?: InputMaybe<Scalars['Int']>;
  diastolicBloodPressure?: InputMaybe<Scalars['Int']>;
  frontPainPoints?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  heartRate?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  respiratoryRate?: InputMaybe<Scalars['Int']>;
  systolicBloodPressure?: InputMaybe<Scalars['Int']>;
  temperature?: InputMaybe<Scalars['Float']>;
  weight?: InputMaybe<Scalars['Int']>;
};

export type WebUser = {
  __typename?: 'WebUser';
  clinics?: Maybe<Array<Maybe<ClinicWebUserInfo>>>;
  organization?: Maybe<Scalars['String']>;
  role: Scalars['String'];
  username: Scalars['String'];
};

export type WebUserInput = {
  organization?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  role?: InputMaybe<Scalars['String']>;
  username: Scalars['String'];
};

export type AudioResultsQueryVariables = Exact<{
  clinicId: Scalars['String'];
  visitId: Scalars['String'];
}>;


export type AudioResultsQuery = { __typename?: 'Query', visit?: { __typename?: 'Visit', transcription?: string | null, questions?: string | null } | null };

export type ClinicPatientsQueryVariables = Exact<{
  clinicId: Scalars['String'];
}>;


export type ClinicPatientsQuery = { __typename?: 'Query', clinic?: { __typename?: 'Clinic', patients?: Array<{ __typename?: 'Patient', patientId: string, patientIdType: string, firstName?: string | null, lastName?: string | null } | null> | null } | null };

export type CreatePatientMutationVariables = Exact<{
  patient: PatientCreation;
}>;


export type CreatePatientMutation = { __typename?: 'Mutation', createPatient?: { __typename?: 'Patient', patientId: string, patientIdType: string } | null };

export type CreateRecordingMutationVariables = Exact<{
  recording: RecordingInput;
}>;


export type CreateRecordingMutation = { __typename?: 'Mutation', createRecording?: { __typename?: 'Recording', uploadUrl?: string | null } | null };

export type CreateSiteNoteMutationVariables = Exact<{
  siteNote: SiteNoteInput;
}>;


export type CreateSiteNoteMutation = { __typename?: 'Mutation', createSiteNote?: { __typename?: 'SiteNote', uploadUrl?: string | null } | null };

export type CreateWebUserMutationVariables = Exact<{
  webUser: WebUserInput;
}>;


export type CreateWebUserMutation = { __typename?: 'Mutation', createWebUser?: { __typename?: 'WebUser', username: string } | null };

export type DeleteRecordingMutationVariables = Exact<{
  recordingKeys: RecordingKeys;
}>;


export type DeleteRecordingMutation = { __typename?: 'Mutation', deleteRecording?: boolean | null };

export type GenerateAssessmentMutationVariables = Exact<{
  clinicId: Scalars['String'];
  visitId: Scalars['String'];
  sessionId: Scalars['String'];
}>;


export type GenerateAssessmentMutation = { __typename?: 'Mutation', generateAssessment?: string | null };

export type InitiateVisitMutationVariables = Exact<{
  visitInfo: InitiateVisitInput;
}>;


export type InitiateVisitMutation = { __typename?: 'Mutation', initiateVisit?: { __typename?: 'Visit', patientId?: string | null, patientIdType?: string | null, visitId: string, urgency?: string | null, waitingFor?: string | null, assocPhysician?: string | null } | null };

export type LoginMutationVariables = Exact<{
  username: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login?: { __typename?: 'WebUser', username: string, role: string } | null };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout?: boolean | null };

export type PatientQueryVariables = Exact<{
  id: Scalars['String'];
  patientIdType: Scalars['String'];
}>;


export type PatientQuery = { __typename?: 'Query', patient?: { __typename?: 'Patient', patientId: string, patientIdType: string, firstName?: string | null, lastName?: string | null, birthday?: any | null } | null };

export type PatientUploadPhotoQueryVariables = Exact<{
  id: Scalars['String'];
  patientIdType: Scalars['String'];
}>;


export type PatientUploadPhotoQuery = { __typename?: 'Query', patient?: { __typename?: 'Patient', photoUploadUrl?: string | null } | null };

export type PatientsByIdQueryVariables = Exact<{
  ids: Array<PatientId> | PatientId;
}>;


export type PatientsByIdQuery = { __typename?: 'Query', patientsById?: Array<{ __typename?: 'Patient', firstName?: string | null, lastName?: string | null, patientId: string, patientIdType: string } | null> | null };

export type PatientMedicationQueryVariables = Exact<{
  id: Scalars['String'];
  patientIdType: Scalars['String'];
}>;


export type PatientMedicationQuery = { __typename?: 'Query', patient?: { __typename?: 'Patient', medications?: Array<{ __typename?: 'Medication', medicationId: string, name: string, dosage: string, status: string, schedule?: Array<number | null> | null } | null> | null } | null };

export type PatientUpdateMutationVariables = Exact<{
  patient: PatientUpdate;
}>;


export type PatientUpdateMutation = { __typename?: 'Mutation', updatePatient?: { __typename?: 'Patient', firstName?: string | null, lastName?: string | null } | null };

export type RecordingsByCriteriaQueryVariables = Exact<{
  criteria: RecordingQueryInput;
}>;


export type RecordingsByCriteriaQuery = { __typename?: 'Query', recordings: Array<{ __typename?: 'Recording', recordingId?: string | null, recordedAt?: any | null, user?: string | null, patientId?: string | null, status?: string | null, assignedTo?: string | null, originalTranscription?: string | null, correctedTranscription?: string | null, altTranscription?: string | null, notes?: string | null } | null> };

export type RecordingQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type RecordingQuery = { __typename?: 'Query', recording: { __typename?: 'Recording', downloadUrl?: string | null } };

export type RecordingsByIdQueryVariables = Exact<{
  ids: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
}>;


export type RecordingsByIdQuery = { __typename?: 'Query', recordingsById: Array<{ __typename?: 'Recording', downloadUrl?: string | null } | null> };

export type SiteNotesQueryVariables = Exact<{
  criteria: SiteNoteQueryInput;
}>;


export type SiteNotesQuery = { __typename?: 'Query', siteNotes: Array<{ __typename?: 'SiteNote', filename?: string | null, noteId?: string | null, user?: string | null, createdAt?: any | null } | null> };

export type SiteNotesByIdQueryVariables = Exact<{
  ids: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
}>;


export type SiteNotesByIdQuery = { __typename?: 'Query', siteNotesById: Array<{ __typename?: 'SiteNote', downloadUrl?: string | null } | null> };

export type StartTranscriptionSessionMutationVariables = Exact<{
  visitId: Scalars['String'];
}>;


export type StartTranscriptionSessionMutation = { __typename?: 'Mutation', startTranscriptionSession?: string | null };

export type TranscribeAudioMutationVariables = Exact<{
  visitId: Scalars['String'];
  sessionId: Scalars['String'];
  audio: Scalars['String'];
}>;


export type TranscribeAudioMutation = { __typename?: 'Mutation', transcribeAudio?: string | null };

export type UpdateRecordingStatusMutationVariables = Exact<{
  keys: RecordingKeys;
  update: RecordingStatusUpdate;
}>;


export type UpdateRecordingStatusMutation = { __typename?: 'Mutation', updateRecordingStatus?: { __typename?: 'Recording', status?: string | null, assignedTo?: string | null } | null };

export type UpdateRecordingNotesMutationVariables = Exact<{
  keys: RecordingKeys;
  update: RecordingNotesUpdate;
}>;


export type UpdateRecordingNotesMutation = { __typename?: 'Mutation', updateRecordingNotes?: { __typename?: 'Recording', originalTranscription?: string | null, correctedTranscription?: string | null, altTranscription?: string | null, notes?: string | null } | null };

export type UpdateVisitDetailsMutationVariables = Exact<{
  patientId: Scalars['String'];
  patientIdType: Scalars['String'];
  createdAt: Scalars['Date'];
  visitId: Scalars['String'];
  clinicId: Scalars['String'];
  visit: VisitInput;
  vitals: VitalsInput;
}>;


export type UpdateVisitDetailsMutation = { __typename?: 'Mutation', updateVisitDetails?: { __typename?: 'Visit', patientId?: string | null, patientIdType?: string | null, visitId: string, chiefComplaint?: string | null, noteToPhysician?: string | null, reasonForComing?: string | null } | null, createVitals?: { __typename?: 'Vitals', patientId: string, patientIdType: string, eventId: string, eventType: string, height?: number | null, weight?: number | null, temperature?: number | null, heartRate?: number | null, respiratoryRate?: number | null, bloodOxygen?: number | null, systolicBloodPressure?: number | null, diastolicBloodPressure?: number | null, frontPainPoints?: Array<number | null> | null, backPainPoints?: Array<number | null> | null } | null };


export type UpdateVisitProgressMutationVariables = Exact<{
  clinicId: Scalars['String'];
  visitId: Scalars['String'];
  visitProgress: VisitProgress;
}>;


export type UpdateVisitProgressMutation = { __typename?: 'Mutation', updateVisitProgress?: { __typename?: 'Visit', patientId?: string | null, patientIdType?: string | null, visitId: string, urgency?: string | null, waitingFor?: string | null, assocPhysician?: string | null } | null };

export type UserForSessionQueryVariables = Exact<{ [key: string]: never; }>;


export type UserForSessionQuery = { __typename?: 'Query', userForSession?: { __typename?: 'WebUser', username: string, role: string, organization?: string | null, clinics?: Array<{ __typename?: 'ClinicWebUserInfo', clinicId?: string | null, name?: string | null, country?: string | null, province?: string | null, city?: string | null, role?: string | null, active?: boolean | null } | null> | null } | null };

export type UsersForRoleQueryVariables = Exact<{
  role: Scalars['String'];
}>;


export type UsersForRoleQuery = { __typename?: 'Query', usersForRole?: Array<string | null> | null };

export type VisitsQueryVariables = Exact<{
  criteria: VisitCriteria;
}>;


export type VisitsQuery = { __typename?: 'Query', visits: Array<{ __typename?: 'Visit', visitId: string, patientId?: string | null, patientIdType?: string | null, urgency?: string | null, waitingFor?: string | null, assocPhysician?: string | null } | null> };

export type VitalsQueryVariables = Exact<{
  patientId: Scalars['String'];
  patientIdType: Scalars['String'];
  eventType: Scalars['String'];
  eventId: Scalars['String'];
}>;


export type VitalsQuery = { __typename?: 'Query', vitals?: { __typename?: 'Vitals', height?: number | null, weight?: number | null, temperature?: number | null, systolicBloodPressure?: number | null, diastolicBloodPressure?: number | null, heartRate?: number | null, respiratoryRate?: number | null, bloodOxygen?: number | null, eventId: string, eventType: string, patientId: string, patientIdType: string, frontPainPoints?: Array<number | null> | null, backPainPoints?: Array<number | null> | null } | null };


export const AudioResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"audioResults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clinicId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"visitId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clinicId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clinicId"}}},{"kind":"Argument","name":{"kind":"Name","value":"visitId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"visitId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transcription"}},{"kind":"Field","name":{"kind":"Name","value":"questions"}}]}}]}}]} as unknown as DocumentNode<AudioResultsQuery, AudioResultsQueryVariables>;
export const ClinicPatientsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"clinicPatients"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clinicId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clinic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clinicId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clinicId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"patients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"patientId"}},{"kind":"Field","name":{"kind":"Name","value":"patientIdType"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]} as unknown as DocumentNode<ClinicPatientsQuery, ClinicPatientsQueryVariables>;
export const CreatePatientDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createPatient"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"patient"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PatientCreation"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPatient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"patient"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patient"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"patientId"}},{"kind":"Field","name":{"kind":"Name","value":"patientIdType"}}]}}]}}]} as unknown as DocumentNode<CreatePatientMutation, CreatePatientMutationVariables>;
export const CreateRecordingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createRecording"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recording"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RecordingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createRecording"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"recording"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recording"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadUrl"}}]}}]}}]} as unknown as DocumentNode<CreateRecordingMutation, CreateRecordingMutationVariables>;
export const CreateSiteNoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createSiteNote"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteNote"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SiteNoteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSiteNote"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"note"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteNote"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadUrl"}}]}}]}}]} as unknown as DocumentNode<CreateSiteNoteMutation, CreateSiteNoteMutationVariables>;
export const CreateWebUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createWebUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"webUser"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WebUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createWebUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"webUser"},"value":{"kind":"Variable","name":{"kind":"Name","value":"webUser"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}}]} as unknown as DocumentNode<CreateWebUserMutation, CreateWebUserMutationVariables>;
export const DeleteRecordingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteRecording"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recordingKeys"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RecordingKeys"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteRecording"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"recording"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recordingKeys"}}}]}]}}]} as unknown as DocumentNode<DeleteRecordingMutation, DeleteRecordingMutationVariables>;
export const GenerateAssessmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"generateAssessment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clinicId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"visitId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateAssessment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clinicId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clinicId"}}},{"kind":"Argument","name":{"kind":"Name","value":"visitId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"visitId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}}}]}]}}]} as unknown as DocumentNode<GenerateAssessmentMutation, GenerateAssessmentMutationVariables>;
export const InitiateVisitDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"initiateVisit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"visitInfo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InitiateVisitInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"initiateVisit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"visitInfo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"visitInfo"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"patientId"}},{"kind":"Field","name":{"kind":"Name","value":"patientIdType"}},{"kind":"Field","name":{"kind":"Name","value":"visitId"}},{"kind":"Field","name":{"kind":"Name","value":"urgency"}},{"kind":"Field","name":{"kind":"Name","value":"waitingFor"}},{"kind":"Field","name":{"kind":"Name","value":"assocPhysician"}}]}}]}}]} as unknown as DocumentNode<InitiateVisitMutation, InitiateVisitMutationVariables>;
export const LoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"login"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"username"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"username"},"value":{"kind":"Variable","name":{"kind":"Name","value":"username"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>;
export const LogoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"logout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logout"}}]}}]} as unknown as DocumentNode<LogoutMutation, LogoutMutationVariables>;
export const PatientDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"patient"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"patientIdType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"patient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"patientIdType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patientIdType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"patientId"}},{"kind":"Field","name":{"kind":"Name","value":"patientIdType"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"patientId"}},{"kind":"Field","name":{"kind":"Name","value":"patientIdType"}}]}}]}}]} as unknown as DocumentNode<PatientQuery, PatientQueryVariables>;
export const PatientUploadPhotoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"patientUploadPhoto"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"patientIdType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"patient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"patientIdType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patientIdType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoUploadUrl"}}]}}]}}]} as unknown as DocumentNode<PatientUploadPhotoQuery, PatientUploadPhotoQueryVariables>;
export const PatientsByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"patientsById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PatientId"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"patientsById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"patientId"}},{"kind":"Field","name":{"kind":"Name","value":"patientIdType"}}]}}]}}]} as unknown as DocumentNode<PatientsByIdQuery, PatientsByIdQueryVariables>;
export const PatientMedicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"patientMedication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"patientIdType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"patient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"patientIdType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patientIdType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"medications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"medicationId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dosage"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"}}]}}]}}]}}]} as unknown as DocumentNode<PatientMedicationQuery, PatientMedicationQueryVariables>;
export const PatientUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"patientUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"patient"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PatientUpdate"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePatient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"patient"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patient"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]} as unknown as DocumentNode<PatientUpdateMutation, PatientUpdateMutationVariables>;
export const RecordingsByCriteriaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"recordingsByCriteria"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"criteria"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RecordingQueryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"criteria"},"value":{"kind":"Variable","name":{"kind":"Name","value":"criteria"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordingId"}},{"kind":"Field","name":{"kind":"Name","value":"recordedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"}},{"kind":"Field","name":{"kind":"Name","value":"patientId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"assignedTo"}},{"kind":"Field","name":{"kind":"Name","value":"originalTranscription"}},{"kind":"Field","name":{"kind":"Name","value":"correctedTranscription"}},{"kind":"Field","name":{"kind":"Name","value":"altTranscription"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}}]}}]} as unknown as DocumentNode<RecordingsByCriteriaQuery, RecordingsByCriteriaQueryVariables>;
export const RecordingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"recording"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recording"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}}]}}]}}]} as unknown as DocumentNode<RecordingQuery, RecordingQueryVariables>;
export const RecordingsByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"recordingsById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordingsById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}}]}}]}}]} as unknown as DocumentNode<RecordingsByIdQuery, RecordingsByIdQueryVariables>;
export const SiteNotesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"siteNotes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"criteria"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SiteNoteQueryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteNotes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"criteria"},"value":{"kind":"Variable","name":{"kind":"Name","value":"criteria"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"noteId"}},{"kind":"Field","name":{"kind":"Name","value":"user"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<SiteNotesQuery, SiteNotesQueryVariables>;
export const SiteNotesByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"siteNotesById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteNotesById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}}]}}]}}]} as unknown as DocumentNode<SiteNotesByIdQuery, SiteNotesByIdQueryVariables>;
export const StartTranscriptionSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"startTranscriptionSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"visitId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startTranscriptionSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"visitId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"visitId"}}}]}]}}]} as unknown as DocumentNode<StartTranscriptionSessionMutation, StartTranscriptionSessionMutationVariables>;
export const TranscribeAudioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"transcribeAudio"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"visitId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"audio"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transcribeAudio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"visitId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"visitId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"audio"},"value":{"kind":"Variable","name":{"kind":"Name","value":"audio"}}}]}]}}]} as unknown as DocumentNode<TranscribeAudioMutation, TranscribeAudioMutationVariables>;
export const UpdateRecordingStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateRecordingStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keys"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RecordingKeys"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"update"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RecordingStatusUpdate"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRecordingStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"recording"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keys"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"update"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"assignedTo"}}]}}]}}]} as unknown as DocumentNode<UpdateRecordingStatusMutation, UpdateRecordingStatusMutationVariables>;
export const UpdateRecordingNotesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateRecordingNotes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keys"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RecordingKeys"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"update"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RecordingNotesUpdate"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRecordingNotes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"recording"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keys"}}},{"kind":"Argument","name":{"kind":"Name","value":"updates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"update"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originalTranscription"}},{"kind":"Field","name":{"kind":"Name","value":"correctedTranscription"}},{"kind":"Field","name":{"kind":"Name","value":"altTranscription"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}}]}}]} as unknown as DocumentNode<UpdateRecordingNotesMutation, UpdateRecordingNotesMutationVariables>;
export const UpdateVisitDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateVisitDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"patientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"patientIdType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdAt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"visitId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clinicId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"visit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VisitInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"vitals"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VitalsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateVisitDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"visitId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"visitId"}}},{"kind":"Argument","name":{"kind":"Name","value":"clinicId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clinicId"}}},{"kind":"Argument","name":{"kind":"Name","value":"visitDetails"},"value":{"kind":"Variable","name":{"kind":"Name","value":"visit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"patientId"}},{"kind":"Field","name":{"kind":"Name","value":"patientIdType"}},{"kind":"Field","name":{"kind":"Name","value":"visitId"}},{"kind":"Field","name":{"kind":"Name","value":"chiefComplaint"}},{"kind":"Field","name":{"kind":"Name","value":"noteToPhysician"}},{"kind":"Field","name":{"kind":"Name","value":"reasonForComing"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createVitals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"patientId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patientId"}}},{"kind":"Argument","name":{"kind":"Name","value":"patientIdType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patientIdType"}}},{"kind":"Argument","name":{"kind":"Name","value":"eventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"visitId"}}},{"kind":"Argument","name":{"kind":"Name","value":"eventType"},"value":{"kind":"StringValue","value":"V","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"vitals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"vitals"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"patientId"}},{"kind":"Field","name":{"kind":"Name","value":"patientIdType"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"temperature"}},{"kind":"Field","name":{"kind":"Name","value":"heartRate"}},{"kind":"Field","name":{"kind":"Name","value":"respiratoryRate"}},{"kind":"Field","name":{"kind":"Name","value":"bloodOxygen"}},{"kind":"Field","name":{"kind":"Name","value":"systolicBloodPressure"}},{"kind":"Field","name":{"kind":"Name","value":"diastolicBloodPressure"}},{"kind":"Field","name":{"kind":"Name","value":"frontPainPoints"}},{"kind":"Field","name":{"kind":"Name","value":"backPainPoints"}}]}}]}}]} as unknown as DocumentNode<UpdateVisitDetailsMutation, UpdateVisitDetailsMutationVariables>;
export const UpdateVisitProgressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateVisitProgress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clinicId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"visitId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"visitProgress"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VisitProgress"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateVisitProgress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clinicId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clinicId"}}},{"kind":"Argument","name":{"kind":"Name","value":"visitId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"visitId"}}},{"kind":"Argument","name":{"kind":"Name","value":"visitProgress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"visitProgress"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"patientId"}},{"kind":"Field","name":{"kind":"Name","value":"patientIdType"}},{"kind":"Field","name":{"kind":"Name","value":"visitId"}},{"kind":"Field","name":{"kind":"Name","value":"urgency"}},{"kind":"Field","name":{"kind":"Name","value":"waitingFor"}},{"kind":"Field","name":{"kind":"Name","value":"assocPhysician"}}]}}]}}]} as unknown as DocumentNode<UpdateVisitProgressMutation, UpdateVisitProgressMutationVariables>;
export const UserForSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userForSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userForSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"clinics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clinicId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"province"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]}}]} as unknown as DocumentNode<UserForSessionQuery, UserForSessionQueryVariables>;
export const UsersForRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"usersForRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usersForRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"role"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}}]}]}}]} as unknown as DocumentNode<UsersForRoleQuery, UsersForRoleQueryVariables>;
export const VisitsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"visits"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"criteria"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VisitCriteria"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"criteria"},"value":{"kind":"Variable","name":{"kind":"Name","value":"criteria"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visitId"}},{"kind":"Field","name":{"kind":"Name","value":"patientId"}},{"kind":"Field","name":{"kind":"Name","value":"patientIdType"}},{"kind":"Field","name":{"kind":"Name","value":"urgency"}},{"kind":"Field","name":{"kind":"Name","value":"waitingFor"}},{"kind":"Field","name":{"kind":"Name","value":"assocPhysician"}}]}}]}}]} as unknown as DocumentNode<VisitsQuery, VisitsQueryVariables>;
export const VitalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"vitals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"patientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"patientIdType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vitals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"patientId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patientId"}}},{"kind":"Argument","name":{"kind":"Name","value":"patientIdType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patientIdType"}}},{"kind":"Argument","name":{"kind":"Name","value":"eventType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventType"}}},{"kind":"Argument","name":{"kind":"Name","value":"eventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"temperature"}},{"kind":"Field","name":{"kind":"Name","value":"systolicBloodPressure"}},{"kind":"Field","name":{"kind":"Name","value":"diastolicBloodPressure"}},{"kind":"Field","name":{"kind":"Name","value":"heartRate"}},{"kind":"Field","name":{"kind":"Name","value":"respiratoryRate"}},{"kind":"Field","name":{"kind":"Name","value":"bloodOxygen"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"patientId"}},{"kind":"Field","name":{"kind":"Name","value":"patientIdType"}},{"kind":"Field","name":{"kind":"Name","value":"frontPainPoints"}},{"kind":"Field","name":{"kind":"Name","value":"backPainPoints"}}]}}]}}]} as unknown as DocumentNode<VitalsQuery, VitalsQueryVariables>;